import dayjs from 'dayjs';
import { ISigningSession } from 'app/shared/model/signing-session.model';
import { SignatureEventType } from 'app/shared/model/enumerations/signature-event-type.model';

export interface ISignatureAuditLog {
  id?: number;
  eventType?: keyof typeof SignatureEventType;
  actor?: string | null;
  ipAddress?: string | null;
  eventTimestamp?: dayjs.Dayjs;
  note?: string | null;
  signingSession?: ISigningSession | null;
}

export const defaultValue: Readonly<ISignatureAuditLog> = {};
